module.exports = __webpack_public_path__ + "static/media/pic_patient@2x.4a2456dc.png";